import * as THREE from 'three';
import { WebGLElement, InvBool, parseVec3, findThreeParent } from './base.js';

export class ThreeCamera extends WebGLElement {
  static properties = {
    ...WebGLElement.properties,
    fov: { type: Number },
    near: { type: Number },
    far: { type: Number },
    lookAt: { type: String, attribute: 'look-at' },
    active: { converter: InvBool, reflect: true },
  };

  constructor() {
    super();
    this.fov = 60;
    this.near = 0.1;
    this.far = 1000;
    this.lookAt = '';
    this.active = true;
  }

  createObject3D() {
    return new THREE.PerspectiveCamera(this.fov, 1, this.near, this.far);
  }

  connectedCallback() {
    super.connectedCallback();
    this._applyLookAt();
    if (this.active) {
      const scene = this.closest('three-scene');
      if (scene && scene.setActiveCamera) scene.setActiveCamera(this.object3D);
    }
  }

  updated(changed) {
    super.updated(changed);
    if (changed.has('fov') || changed.has('near') || changed.has('far')) {
      this.object3D.fov = this.fov;
      this.object3D.near = this.near;
      this.object3D.far = this.far;
      this.object3D.updateProjectionMatrix();
    }
    if (changed.has('lookAt') || changed.has('position')) {
      this._applyLookAt();
    }
  }

  _applyLookAt() {
    if (!this.lookAt) return;
    const [x, y, z] = parseVec3(this.lookAt);
    this.object3D.lookAt(x, y, z);
  }
}

customElements.define('three-camera', ThreeCamera);
